var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareersIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96452 4L6.38988 11.3903C6.26457 11.9785 6.33354 12.1987 6.76545 12.621L8.51219 14.3289C8.74245 14.5541 8.85759 14.6667 9.00065 14.6667C9.14372 14.6667 9.25885 14.5541 9.48912 14.3289L11.2359 12.621C11.6678 12.1987 11.7367 11.9785 11.6115 11.3903L10.0368 4",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03785 2.0827C6.99292 1.73344 6.97045 1.55881 7.07285 1.44608C7.17532 1.33334 7.35645 1.33334 7.71872 1.33334H10.2813C10.6435 1.33334 10.8247 1.33334 10.9271 1.44608C11.0295 1.55881 11.0071 1.73344 10.9621 2.0827L10.9283 2.34622C10.8332 3.0848 10.7857 3.45408 10.5483 3.69367C10.5097 3.7326 10.4679 3.76842 10.4233 3.80079C10.1492 4.00001 9.76612 4.00001 8.99998 4.00001C8.23385 4.00001 7.85078 4.00001 7.57665 3.80079C7.53212 3.76842 7.49032 3.7326 7.45172 3.69367C7.21425 3.45408 7.16678 3.0848 7.07172 2.34621L7.03785 2.0827Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 10C6.26214 10.4617 5.91906 10.6667 5.66732 10.6667C5.3444 10.6667 4.76305 9.85293 4.50504 9.2636C4.38398 8.98707 4.32345 8.8488 4.33549 8.67387C4.34752 8.49893 4.42681 8.371 4.58538 8.11513C5.48207 6.66827 7.01033 5.34742 8.00066 4",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersIc);
export default __webpack_public_path__ + "static/media/careers_ic.dffe71c3e379767d8d3a09293d4520ee.svg";
export { ForwardRef as ReactComponent };